import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts',
  templateUrl: './funfacts.component.html',
  styleUrls: ['./funfacts.component.scss']
})
export class FunfactsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
